import { hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";
import "./styles/sprite.scss";
import Providers from "./Providers";
import { addPageAttributesToReporting } from "./utils/addPageAttributesToReporting";
import getRuntimeConstants from "./runtimeConstants";
import getWindow from "./utils/window";
import { logError, ERROR_TYPE } from "./utils/newRelicLogger";

getWindow().dispatchEvent(new Event("PDPApplicationStart"));
getWindow().asos.pdp.appStarted = true;

const onRecoverableError = (error) => {
  logError(ERROR_TYPE.NonCriticalAppError, {
    message: error?.message ?? String(error),
    action: "ReactHydration",
  });
};

loadableReady(() => {
  hydrateRoot(
    document.getElementById("pdp-react-critical-app"),
    <Providers runtimeConstants={getRuntimeConstants()} />,
    { onRecoverableError },
  );
});

addPageAttributesToReporting();
